import React from "react";
import Modal from "./Modal";

export type ShiftNotVisibleReason =
    | { kind: "filtered"; label: string; mode: "byLocation" | "byEmployee" }
    | { kind: "noTimeline" }
    | { kind: "notInSchedule" };

type ShiftNotVisibleModalProps = {
    open: boolean;
    onClose: () => void;
    reason: ShiftNotVisibleReason | null;
};

const ShiftNotVisibleModal: React.FC<ShiftNotVisibleModalProps> = ({ open, onClose, reason }) => {
    let body: React.ReactNode = null;

    if (reason?.kind === "filtered") {
        const what = reason.mode === "byEmployee" ? "l'employé" : "le rôle";
        const label = reason.label || (reason.mode === "byEmployee" ? "cet employé" : "ce rôle");
        body = (
            <p className="text-gray-700">
                Ce quart n'est pas affiché : {what} <span className="font-medium">{label}</span>{" "}
                est masqué par le filtre actif. Il doit être réactivé dans le filtre pour que le quart
                apparaisse dans l'horaire.
            </p>
        );
    } else if (reason?.kind === "notInSchedule") {
        body = (
            <p className="text-gray-700">
                Ce quart est introuvable dans l'horaire actuellement affiché : il a probablement changé
                depuis le calcul de l'analyse. Un rafraîchissement de l'horaire, suivi d'une nouvelle
                analyse, devrait rétablir la correspondance.
            </p>
        );
    } else if (reason?.kind === "noTimeline") {
        body = (
            <p className="text-gray-700">
                Ce quart ne peut être affiché que dans « Prévisualisation par rôle » ou
                « Prévisualisation par employé ». L'un de ces onglets doit être ouvert au préalable.
            </p>
        );
    }

    return (
        <Modal
            open={open}
            onClose={onClose}
            title="Quart non affiché"
            size="md"
            footer={
                <button
                    onClick={onClose}
                    className="inline-flex items-center rounded-full bg-green-600 px-4 py-2 font-medium text-white cursor-pointer hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                >
                    Compris
                </button>
            }
        >
            {body}
        </Modal>
    );
};

export default ShiftNotVisibleModal;
